const defaultInputMapping = {
  utm_1: '', utm_2: '', utm_3: '', utm_4: '', utm_5: '',
};

export default defaultInputMapping;
